import { createVanIconComponent } from "./van"

const ArrowDown = createVanIconComponent("arrow-down")
export default ArrowDown
